import { createContext } from 'react';

export interface FeatureAppConfig {
  globalApi: string,
  imageBaseUrl: string
};

export const AppContext = createContext<FeatureAppConfig>({
  globalApi: "https://globalapi.vwtools.ca",
  imageBaseUrl: "https://vw-canada-websites.s3.amazonaws.com/maintenance-timeline/vehicles"
});
